import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowLeft, MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/919174174174?text=Hi";

export default function EnquiryPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [fullName, setFullName] = useState(user?.full_name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [mobile, setMobile] = useState(user?.mobile || "");

  const canChat = fullName.trim() && email.trim() && mobile.trim().length === 10;

  const openWhatsApp = () => {
    window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="space-y-4" data-testid="enquiry-page">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="p-1.5 rounded-lg hover:bg-gray-100" data-testid="enquiry-back-btn"><ArrowLeft className="w-5 h-5" /></button>
        <h1 className="text-xl font-bold text-gray-900">Product Enquiry</h1>
      </div>
      <div>
        <label className="text-xs font-semibold text-gray-500 tracking-wide">Full Name *</label>
        <input type="text" value={fullName} onChange={e => setFullName(e.target.value)} placeholder="Enter full name"
          className="mt-1 w-full px-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-[#008A99]" data-testid="enquiry-name" />
      </div>
      <div>
        <label className="text-xs font-semibold text-gray-500 tracking-wide">Email *</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter email"
          className="mt-1 w-full px-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-[#008A99]" data-testid="enquiry-email" />
      </div>
      <div>
        <label className="text-xs font-semibold text-gray-500 tracking-wide">Mobile Number *</label>
        <input type="tel" value={mobile} onChange={e => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))} placeholder="10-digit mobile"
          className="mt-1 w-full px-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-[#008A99]" data-testid="enquiry-mobile" />
      </div>
      <button
        onClick={openWhatsApp}
        disabled={!canChat}
        className="w-full py-3 bg-[#25D366] text-white rounded-xl font-semibold text-sm flex items-center justify-center gap-2 disabled:opacity-50 disabled:bg-gray-300 hover:bg-[#1FAE54] transition-colors"
        data-testid="whatsapp-enquiry-btn"
      >
        <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
      </button>
    </div>
  );
}
